module.exports = __webpack_public_path__ + "img/icon-left.a3308630.svg";